import { makeStyles } from '@material-ui/core';

const useCustomCodatButtonStyles = makeStyles({
  successfulConnection: {
    color: 'green'
  },
  successfulBox: {
    justifyContent: 'start',
    display: 'flex',
    width: '100%',
    color: '#212121',
    height: '2.2rem',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    alignItems: 'center',
    paddingLeft: '0.5rem',
    borderRadius: '0.25rem'
  },
  box: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    background: '#007DB8',
    fontWeight: 500,    
    color: '#FFFFFF',
    padding: '8px',
    "&:hover": {
      background: '#007DB8'
    }
    
  },
  connectedItem: {
    fontWeight: 500,
    fontSize: '0.875rem',
    paddingInlineStart: '0.8rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  buttonText: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    marginRight: '10px'
  },
  connectionPlatform: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    gap: '16px'
  },
  connectionBanner: {
    display: 'flex',
    padding: 'var(--space-3x, 12px)',
    alignItems: 'flexStart',
    gap: 'var(--space-2x, 8px)',
    borderRadius: 'var(--radius-medium, 4px)',
    border: '1px solid var(--border-warning, #FFAB75)',
    background: 'var(--fill-warning, #FFE8D9)'
  },
  connectionWarningIcon: {
    width: '20px',
    height: '20px',
    flexShrink: 0,
  },
  connectionText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    flex: '1 0 0'
  },
  connectionTextHeading : {
    alignSelf: 'stretch',
    color: 'var(--text-default, #212121)',
    fontFamily: 'var(--font-family-font-sans, Roboto)',
    fontSize: 'var(--font-size-font-size-14, 14px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--styles-body-2-medium-line-height, 20px)'
  },
  connectionTextDescription: {
    alignSelf: 'stretch',
    color: 'var(--text-default, #212121)',
    fontFamily: 'var(--font-family-font-sans, Roboto)',
    fontSize: 'var(--font-size-font-size-14, 14px)',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--styles-body-2-regular-line-height, 20px)'
  },
  disclosure: {
    color: 'var(--neutrals-grey-600, #757575)',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  privacyStatementLink: {
    color: 'inherit',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'auto',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
  }
  
});

export default useCustomCodatButtonStyles;
